/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { getPagesInDOM, getTotalPages, getPagesInView } from "selectors/documentSelectors";
import { TabbingSupport } from "components/accessibility/TabbingSupport";
import { shouldRenderTabbingSupport } from "selectors/accessibilitySelectors";
import { findAndFocusTabbableItemInsideDOM, findAndFocusTabbableItemOutsideDOM } from "utils/AccessibilityUtils";

const mapStoresToProps = stores => ({
  shouldRender: shouldRenderTabbingSupport(stores),
  onFocus: () => {
    const { start: firstPageInDOM, end: lastPageInDOM } = getPagesInDOM(stores);
    const { start: firstPageInView } = getPagesInView(stores);

    for (let pageIndex = firstPageInView; pageIndex <= lastPageInDOM; pageIndex++)
      if (findAndFocusTabbableItemInsideDOM(stores, pageIndex, true)) return;
    for (let pageIndex = lastPageInDOM + 1; pageIndex < getTotalPages(stores); pageIndex++)
      if (findAndFocusTabbableItemOutsideDOM(stores, pageIndex, true)) return;
    for (let pageIndex = 0; pageIndex < firstPageInDOM; pageIndex++)
      if (findAndFocusTabbableItemOutsideDOM(stores, pageIndex, true)) return;
    for (let pageIndex = firstPageInDOM; pageIndex < firstPageInView; pageIndex++)
      if (findAndFocusTabbableItemInsideDOM(stores, pageIndex, true)) return;
  },
  testId: "forward-tabbing"
});

const ForwardTabbingContainer = inject(mapStoresToProps)(TabbingSupport);

export { ForwardTabbingContainer };
